import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef } from 'react';
import styled, { useTheme } from 'styled-components';
import ReactModal from 'react-modal';
import 'react-error-boundary';
import '../../theme/globalStyles.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import '../../theme/base/index.js';
import '../../theme/baseFit/index.js';
import '../../theme/pureGym/index.js';
import '../../theme/fitnessWorld/index.js';
import { Button } from '../button/index.js';
import { Heading } from '../heading/index.js';
import { IconClose } from '../icons/generated/Close.js';
import { BUTTON_VARIANTS } from '../button/constants.js';

var _templateObject, _templateObject2, _templateObject3;
const ModalContent = /*#__PURE__*/styled.section.withConfig({
  displayName: "modal__ModalContent",
  componentId: "sc-sr33ty-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n"])));
const ModalHeader = /*#__PURE__*/styled.div.withConfig({
  displayName: "modal__ModalHeader",
  componentId: "sc-sr33ty-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: ", ";\n  margin-bottom: ", ";\n\n  ", " {\n    margin-block-end: 0;\n  }\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.spacing.threeQuarterSpacing;
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.spacing.threeQuarterSpacing;
}, Heading);
const ModalBody = /*#__PURE__*/styled.div.withConfig({
  displayName: "modal__ModalBody",
  componentId: "sc-sr33ty-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  flex-grow: 1;\n  overflow: auto;\n"])));

/**
 *
 * To enable the Modal to correctly hide the rest of the page content (using
 * `aria-hidden`), you must call `updateAppElement` with a query selector
 * identifying the root of your app.
 *
 * @example for a Gatsby site:
 * updateAppElement('#___gatsby');
 *
 * @see https://reactcommunity.org/react-modal/accessibility/
 */
const Modal = /*#__PURE__*/forwardRef(function Modal(_ref3, ref) {
  let {
    children,
    closeText,
    headingText,
    isOpen,
    modalWide,
    onAfterClose,
    onAfterOpen,
    onClose,
    showCloseButton = true,
    ...rest
  } = _ref3;
  const {
    colors,
    page,
    radii,
    spacing
  } = useTheme();
  return /*#__PURE__*/jsx(ReactModal, {
    ref: ref,
    isOpen: isOpen,
    onAfterOpen: onAfterOpen,
    onAfterClose: onAfterClose,
    onRequestClose: onClose,
    defaultStyles: {
      overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        zIndex: '1000',
        backgroundColor: colors.opacities.invertedStrong,
        padding: spacing.doubleSpacing
      },
      content: {
        position: 'relative',
        maxHeight: '100%',
        margin: 'auto',
        overflow: 'auto',
        WebkitOverflowScrolling: 'touch',
        padding: spacing.doubleSpacing,
        border: "1px solid ".concat(colors.accents.muted),
        borderRadius: radii.default,
        background: colors.background,
        maxWidth: modalWide ? page.maxWidth : '690px'
      }
    },
    ...rest,
    children: /*#__PURE__*/jsxs(ModalContent, {
      children: [/*#__PURE__*/jsxs(ModalHeader, {
        children: [/*#__PURE__*/jsx(Heading, {
          as: "h1",
          variant: "beta",
          children: headingText
        }), showCloseButton && /*#__PURE__*/jsx(Button, {
          variant: BUTTON_VARIANTS.PLAIN,
          "aria-label": closeText,
          onClick: onClose,
          children: /*#__PURE__*/jsx(IconClose, {
            title: closeText
          })
        })]
      }), /*#__PURE__*/jsx(ModalBody, {
        children: children
      })]
    })
  });
});
const updateAppElement = element => ReactModal.setAppElement(element);
Modal.defaultProps = {
  modalWide: false
};

export { Modal, updateAppElement };
